export const TestIds = {
  linkButton: 'linkButton',
  linkInput: 'linkInput',
  linkUpdate: 'linkUpdate',
  linkCancel: 'linkCancel',
  linkRemove: 'linkCancel',
  textSizeButton: 'textSizeButton',
  boldButton: 'boldButton',
  italicButton: 'italicButton',
  alignButton: 'alignButton',
  underlineButton: 'underlineButton',
  orderedListButton: 'orderedListButton',
  unOrderedListButton: 'unOrderedListButton',
  scroller: 'scroller',
  label: 'label',
  tooltip: {
    root: 'tooltip-root',
    content: 'tooltip-content',
    trigger: 'tooltip-trigger',
  },
  toolbar: 'toolbar',
} as const;

export const SHOW_TOOLTIPS_EXPERIMENT =
  'specs.thunderbolt.richTextBoxShowTooltips';

export const TranslationKeys = {
  toolbarBoldPc: {
    key: 'rich_text_box_toolBar_bold_PC_UoU',
    fallback: 'Bold (Ctrl+B)',
  },
  toolbarBoldMac: {
    key: 'rich_text_box_toolBar_bold_mac_UoU',
    fallback: 'Bold (⌘+B)',
  },
  toolbarItalicPc: {
    key: 'rich_text_box_toolBar_italic_PC_UoU',
    fallback: 'Italic (Ctrl+I)',
  },
  toolbarItalicMac: {
    key: 'rich_text_box_toolBar_italic_mac_UoU',
    fallback: 'Italic (⌘+I)',
  },
  toolbarUnderlinePc: {
    key: 'rich_text_box_toolBar_underline_PC_UoU',
    fallback: 'Underline (⌘+U)',
  },
  toolbarUnderlineMac: {
    key: 'rich_text_box_toolBar_underline_mac_UoU',
    fallback: 'Underline (Ctrl+U)',
  },
  toolbarNormalText: {
    key: 'rich_text_box_toolbar_normal_text_UoU',
    fallback: 'Normal text',
  },
  toolbarNormalTextPc: {
    key: 'rich_text_box_toolBar_normal_text_PC_UoU',
    fallback: 'Ctrl+Alt+0',
  },
  toolbarNormalTextMac: {
    key: 'rich_text_box_toolBar_normal_text_mac_UoU',
    fallback: '⌘+Option+0',
  },
  toolbarTitle: { key: 'rich_text_box_toolbar_title_UoU', fallback: 'Title' },
  toolbarTitlePc: {
    key: 'rich_text_box_toolBar_title_PC_UoU',
    fallback: 'Ctrl+Alt+2',
  },
  toolbarTitleMac: {
    key: 'rich_text_box_toolBar_title_mac_UoU',
    fallback: '⌘+Shift+2',
  },
  toolbarSubtitle: {
    key: 'rich_text_box_toolbar_subtitle_UoU',
    fallback: 'Subtitle',
  },
  toolbarSubtitlePc: {
    key: 'rich_text_box_toolBar_subtitle_PC_UoU',
    fallback: 'Ctrl+Alt+3',
  },
  toolbarSubtitleMac: {
    key: 'rich_text_box_toolBar_subtitle_mac_UoU',
    fallback: '⌘+Option+3',
  },
  textSizeSelected: {
    key: 'rich_text_box_toolbar_styles',
    fallback: 'Styles',
  },
  textSizeTitleSelected: {
    key: 'rich_text_box_toolbar_title_selected_A11y',
    fallback: 'Title selected',
  },
  textSizeSubtitleSelected: {
    key: 'rich_text_box_toolbar_subtitle_selected_A11y',
    fallback: 'Subtitle selected',
  },
  textSizeNormalTextSelected: {
    key: 'rich_text_box_toolbar_normal_text_selected_A11y',
    fallback: 'Normal text selected',
  },
  toolbarLinkPc: {
    key: 'rich_text_box_toolBar_link_PC_UoU',
    fallback: 'Link (Ctrl+K)',
  },
  toolbarLinkMac: {
    key: 'rich_text_box_toolBar_link_mac_UoU',
    fallback: 'Link (⌘K)',
  },
  toolbarAlign: { key: 'rich_text_box_toolbar_align', fallback: 'Align' },
  toolbarAlignRightPc: {
    key: 'rich_text_box_toolbar_right_align_PC_UoU',
    fallback: 'Right (Ctrl+Shift+R)',
  },
  toolbarAlignRightMac: {
    key: 'rich_text_box_toolbar_right_align_mac_UoU',
    fallback: 'Right (⌘+Shift+R)',
  },
  toolbarAlignLeftPc: {
    key: 'rich_text_box_toolbar_left_align_PC_UoU',
    fallback: 'Left (Ctrl+Shift+L)',
  },
  toolbarAlignLeftMac: {
    key: 'rich_text_box_toolbar_left_align_mac_UoU',
    fallback: 'Left (⌘+Shift+L)',
  },
  toolbarAlignCenterPc: {
    key: 'rich_text_box_toolbar_center_align_PC_UoU',
    fallback: 'Center (Ctrl+Shift+E)',
  },
  toolbarAlignCenterMac: {
    key: 'rich_text_box_toolbar_center_align_mac_UoU',
    fallback: 'Center (⌘+Shift+E)',
  },
  toolbarAlignJustifyPc: {
    key: 'rich_text_box_toolbar_justify_PC_UoU',
    fallback: 'Justify (Ctrl+Shift+J)',
  },
  toolbarAlignJustifyMac: {
    key: 'rich_text_box_toolbar_justify_mac_UoU',
    fallback: 'Justify (⌘+Shift+J)',
  },
  alignRightSelected: {
    key: 'rich_text_box_toolbar_right_align_selected_A11y',
    fallback: 'Right align selected',
  },
  alignLeftSelected: {
    key: 'rich_text_box_toolbar_left_align_selected_A11y',
    fallback: 'Left align selected',
  },
  alignCenterSelected: {
    key: 'rich_text_box_toolbar_center_align_selected_A11y',
    fallback: 'Center align selected',
  },
  alignJustifySelected: {
    key: 'rich_text_box_toolbar_justify_selected_A11y',
    fallback: 'Justify selected',
  },
  toolbarNumberedListPc: {
    key: 'rich_text_box_toolbar_numbered_list_PC_UoU',
    fallback: 'Numbered list (Ctrl+Shift+7)',
  },
  toolbarNumberedListMac: {
    key: 'rich_text_box_toolBar_numbered_list_mac_UoU',
    fallback: 'Numbered list (⌘+Shift+7)',
  },
  toolbarBulletedListPc: {
    key: 'rich_text_box_toolbar_bulleted_list_PC_UoU',
    fallback: 'Bulleted list (Ctrl+Shift+8)',
  },
  toolbarBulletedListMac: {
    key: 'rich_text_box_toolBar_bulleted_list_mac_UoU',
    fallback: 'Bulleted list (⌘+Shift+8)',
  },
  toolbarLinkLabel: {
    key: 'rich_text_box_link_modal_label_UoU',
    fallback: 'Link',
  },
  toolbarLinkPlaceholder: {
    key: 'rich_text_box_link_modal_placeholder_UoU',
    fallback: 'e.g., www.wix.com',
  },
  toolbarLinkCheckbox: {
    key: 'rich_text_box_link_modal_checkbox_UoU',
    fallback: 'Open in a new tab',
  },
  toolbarLinkUpdateButton: {
    key: 'rich_text_box_link_modal_update_button_UoU',
    fallback: 'Update',
  },
  toolbarLinkCancelButton: {
    key: 'rich_text_box_link_modal_cancel_button_UoU',
    fallback: 'Cancel',
  },
  linkErrorInvalidUrl: {
    key: 'rich_text_box_link_modal_link_error_message',
    fallback: 'Enter a valid website URL.',
  },
  toolbarRemoveLinkButton: {
    key: 'rich_text_box_link_modal_Remove_UoU',
    fallback: 'Remove',
  },
  toolbarAddLinkLabel: {
    key: 'rich_text_box_link_modal_add_link_header_UoU',
    fallback: 'Add Link',
  },
};

export const RICH_TEXT_BOX_NAMESPACE = 'rich_text';
